<template>
  <div class="box1-container">
    <div class="content">
      <div class="box_s">
        <div class="boxs_one">
          <div class="boxs_num"><span>{{ itemData.total }}</span></div>
          <div class="boxs_text">{{$t("home.box1.text1")}}</div>
        </div>
        <div class="boxs_one">
          <div class="boxs_num"><span class="orange">{{ parseInt(itemData.cost_electricity) }}</span></div>
          <div class="boxs_text">{{$t("home.box1.text2")}}</div>
        </div>
        <div class="boxs_one">
          <div class="boxs_num"><span class="green">{{ parseInt(itemData.avg_save_electricity) }}</span></div>
          <div class="boxs_text">{{$t("home.box1.text3")}}</div>
        </div>
      </div>
      <ul class="box_x">
        <li>
          <div class="li_pad">
            {{ itemData.cloud_box }}
            <em>{{$t("home.box1.text4")}}</em>
          </div>
        </li>
        <li>
          <div class="li_pad">
            {{ ip }}
            <em>{{$t("home.box1.text5")}}</em>
          </div>
        </li>
        <li>
          <div class="li_pad">
            {{ camera }}
            <em>{{$t("home.box1.text6")}}</em>
          </div>
        </li>

        <li>
          <div class="li_pad">
            {{ itemData.wifi }}
            <em>WIFI</em>
          </div>
        </li>

        <li>
          <div class="li_pad">
            {{ itemData.air }}
            <em>{{$t("home.box1.text7")}}</em>
          </div>
        </li>

        <li>
          <div class="li_pad">
            {{ itemData.g5 }}
            <em>{{$t("home.box1.text8")}}</em>
          </div>
        </li>

        <li>
          <div class="li_pad">
            {{ alarm }}
            <em>{{$t("home.box1.text9")}}</em>
          </div>
        </li>

        <li>
          <div class="li_pad">
            {{ itemData.charging_pile }}
            <em>{{$t("home.box1.text10")}}</em>
          </div>
        </li>
      </ul>

    </div>
  </div>
</template>

<script>
export default {
  name: "Box1",
  props: {
    itemData: {
      type: Object,
      required: true, // 默认值是false
      default: function () {
        return {
          total:	57,
          online:	3,
          lamp_id:	73,
          cost_electricity:	515.09,
          total_electricity:	630.72,
          avg_cost_electricity:	1.18,
          avg_total_electricity:	1.44,
          save_electricity:	115.63,
          avg_save_electricity:	0.26,
          wifi:	0,
          air:	0,
          g5:	0,
          charging_pile: 1,
        };
      },
    },
    camera: {
      type: Number,
      required: true, // 默认值是false
      default: function () {
        return 0
      }
    },
    ip: {
      type: Number,
      required: true, // 默认值是false
      default: function () {
        return 0
      },
    },
    alarm: {
      type: Number,
      required: true, // 默认值是false
      default: function () {
        return 0
      }
    }
  },
  data() {
    return {}
  },
};
</script>
<style lang='less'>
.box1-container {
  width: 100%;
  height: 100%;
  position: relative;
  
  .content {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right:0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    padding: 15px 0;
    .box_s{
      height:105px;
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      flex-direction: row;
      padding-bottom: 5px;
      box-sizing: border-box;
      .boxs_one{
        width:30%;
        height:98px;
        position: relative;
        background-image: url(../../assets/home_images/box1_pan_03.png);
        background-position: center center;
        background-repeat: no-repeat;
        background-size: auto 100%;
        .boxs_num{
          width:100%;
          height:65px;
          box-sizing: border-box;
          padding-top: 25px;
          display: flex;
          align-items: center;
          justify-content: center;
          span{
            font-size: 26px;
            font-family: Bahnschrift, Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
            font-style: normal;
            color: #67caeb;
            &.orange{
              color: #ffac00;
            }
            &.green{
              color:#39e749
            }
          }
          
        }
        .boxs_text{
          line-height: 28px;
          font-size: 12px;
          color:#fff;
          overflow: hidden;
          text-align: center;
        }
      }
    }
    ul.box_x {
      display: flex;
	    flex-wrap: wrap; 
      list-style: none;
      margin:0 -4px;
      padding: 0;
      li {
        width: 25%; 
        overflow: hidden;
        margin-top:10px;
        padding: 5px;
        box-sizing: border-box;
        .li_pad{
          background-image: url(../../assets/home_images/li_bg.png);
          background-position: 0 0;
          background-repeat: repeat-x;
          background-size: auto 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          font-size: 22px;
          font-weight: normal;
          color: #fff;
          font-family: Bahnschrift, Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
          padding: 3px 0;
          em{
            font-size:12px;
            color:#fff;
            display: block;
            font-style: normal;
            font-weight: 600;
            margin-top: 1px;
            color: #6496c3;
            font-family:  PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
          }
        }

        
      }
    }

  }
}
</style>
